import React from 'react'
import { Route } from 'react-router'
import App from './containers/App'
import StoreLocator from './containers/StoreLocator/StoreLocator'
import StoreDetail from './containers/StoreDetail/StoreDetail'
import NoMatch from './containers/NoMatch/NoMatch'

export default (
  <Route component={App}>
    <Route path='/stores' component={StoreLocator} />
    <Route path='/stores/' component={StoreLocator} />
    <Route path='/stores/search/:searchQuery' component={StoreLocator} />
    <Route path='/stores/?search=:searchQuery' component={StoreLocator} />
    <Route path='/stores/:storeId' component={StoreDetail} />
    <Route path='/stores/not-found' component={NoMatch} status={404} />
    <Route path='*' component={NoMatch} status={404} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes.js